import {getClinetIP} from '../../../../utils/custom-api-utils'
import {sha256} from '../../../../utils/custom-utils'
import {getCookieId} from '../../../../utils/custom-utils'

/**
 * Build common params for GTM Events
 */
export const commonParams = async (gtmContext) => {
    const ip = await getClinetIP(gtmContext?.appOrigin)
    const hashedIpAddress = await sha256(ip)
    const sessionId = await getCookieId('sid')
    let hashedEmailAddress = ''
    if (gtmContext?.email) {
        hashedEmailAddress = await sha256(gtmContext?.email)
    }

    return {
        currencyCode: gtmContext?.currencyCode,
        locale: gtmContext?.localeID,
        pageLanguage: gtmContext?.pageLanguage,
        email: gtmContext?.email ?? '',
        hashedemail: hashedEmailAddress,
        registered: gtmContext?.registered,
        demandwareID: gtmContext?.demandwareID,
        loggedInState: gtmContext?.loggedInState,
        sessionId: sessionId ?? '',
        user_id: gtmContext?.user_id ?? '',
        useragent: gtmContext?.userAgent,
        rawip: ip,
        hashedip: hashedIpAddress,
        facebookclickid: gtmContext?.fbclid ?? '',
        snapchatclickid: gtmContext?.scCid ?? '',
        tiktokclickid: gtmContext?.ttclid ?? '',
        environment: gtmContext?.environment
    }
}
